
import Stickynote from "../../../assets/filled/Stickynote.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function StickynoteIcon({ className, dataTestid = "StickynoteIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Stickynote data-testid={dataTestid} className={classes} {...rest} />
  );
}
